import {experimentation} from '@microsoft/office-experimentation-web';
import {CHANGE_GATE_PREFIX, CHANGE_GATE_WIN32_PREFIX} from '../AppConstants';
import { TranscriberType } from '@augloop-types/voice';
import { CopilotLicenseType } from '@augloop/types-core';

// List of change gates
export const isUseCustomIconServer = experimentation.getBooleanFeatureGate(
  CHANGE_GATE_PREFIX + 'isUseCustomIconServer',
  true,
);

export const transcriberType = (() => {
  const webConfig = experimentation.getStringFeatureGate(
    CHANGE_GATE_PREFIX + 'transcriberType',
    '',
  );
  const win32Config = experimentation.getStringFeatureGate(
    CHANGE_GATE_WIN32_PREFIX + 'transcriberType',
    '',
  );
  return webConfig || win32Config || TranscriberType.Cts;
})();

export const enableConversationTranscriptionV3 = (() => {
  const webConfig = experimentation.getBooleanFeatureGate(
    CHANGE_GATE_PREFIX + 'ConversationTranscriptionV3',
    false,
  );
  const win32Config = experimentation.getBooleanFeatureGate(
    CHANGE_GATE_WIN32_PREFIX + 'ConversationTranscriptionV3',
    false,
  );
  return webConfig || win32Config || false;
})();

export const targetCopilotLicenseType = (() => {
  const webConfig = experimentation.getIntFeatureGate(
    CHANGE_GATE_PREFIX + 'TargetCopilotLicenseType',
    0, // Unknown(0), CopilotInM365(1), CopilotPro(2), CopilotEnterprise(3)
  );
  const win32Config = experimentation.getIntFeatureGate(
    CHANGE_GATE_WIN32_PREFIX + 'TargetCopilotLicenseType',
    0, // Unknown(0), CopilotInM365(1), CopilotPro(2), CopilotEnterprise(3)
  );
  return webConfig || win32Config || CopilotLicenseType.CopilotEnterprise;
})();

export const enableCopilotLicenseCheck = (() => {
  const webConfig = experimentation.getBooleanFeatureGate(
    CHANGE_GATE_PREFIX + 'EnableCopilotLicenseCheck',
    false,
  );
  const win32Config = experimentation.getBooleanFeatureGate(
    CHANGE_GATE_WIN32_PREFIX + 'EnableCopilotLicenseCheck',
    false,
  );

  return webConfig || win32Config || false;
})();

export const enable1CdnLoginUrl = (() => {
  const webConfig = experimentation.getBooleanFeatureGate(
    CHANGE_GATE_PREFIX + 'Enable1CdnLoginUrl',
    false,
  );
  const win32Config = experimentation.getBooleanFeatureGate(
    CHANGE_GATE_WIN32_PREFIX + 'Enable1CdnLoginUrl',
    false,
  );
  return webConfig || win32Config || false;
})();
